import React from "react";
import Icon, { IconProps } from "./Icon";

/**
 * X Circle icon for error or invalid state
 */
export const XCircleIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="15" y1="9" x2="9" y2="15"></line>
      <line x1="9" y1="9" x2="15" y2="15"></line>
    </Icon>
  );
};

export default XCircleIcon;
